export function extFormatDate(date: Date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
}
export function getTimeByGMT(offset: number | string): number {
    const numericOffset = Number(offset);  
    if (!Number.isFinite(numericOffset)) {
        throw new Error(`Invalid GMT offset: ${offset}`);
    }
    const now = new Date();
    const utcMs = now.getTime() + now.getTimezoneOffset() * 60_000;
    const targetTime = new Date(utcMs + numericOffset * 3_600_000);

    return targetTime.getHours() * 60 + targetTime.getMinutes();
}